export class UserInterface {
	public static header: Header;
}

export class Header {
	public title: string;
	public strongTitle: string;
	public actions: Link[];

	public static Init(): Header {
		let initialHeader: Header = {
			title: 'Welcome to',
			strongTitle: 'National Bank of Greece',
			actions: [{ title: 'Contact Us', route: '/contact', iconClass: 'contact' }]
		};
		return initialHeader;
	}
}

export class Link {
	public title: string;
	public route?: string;
	public iconClass?: string;
	public operation?: () => void;
}
